$(function() {
    window.isMenuOpen = false;
    const elements = document.querySelectorAll(".js_fade_in,.js_fade_box,js_fade_in_history");
    const onScroll = () => {
        elements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.9) {
                el.classList.add("is_visible");
            }
        });
    };
    window.addEventListener("scroll", onScroll);
    window.addEventListener("load", onScroll);
    onScroll();

    const isEnglish = window.location.pathname.includes('/en/');
    const langItems = document.querySelectorAll('.bl_langList li');

    langItems.forEach(item => {
        const label = item.getAttribute('aria-label');
        if (isEnglish && label === 'EN') {
            item.classList.add('is_current');
        } else if (!isEnglish && label === 'JP') {
            item.classList.add('is_current');
        } else {
            item.classList.remove('is_current');
        }
    });
    // url hash
	var urlHash = location.hash;
	var header_size = $("#header").outerHeight();
	if (urlHash) {
		$('body,html').stop().scrollTop(0);
		setTimeout(function() {
			scrollToAnker(urlHash);
		}, 100);
	}
    // hash scroll
	function scrollToAnker(hash) {
		var target = $(hash);
		var position = target.offset().top - header_size;
		$('body,html').stop().animate({
			scrollTop: position
		}, 500);
	}

    var winScrollTop;
    var modal = $(".js_movie_modal"); // モーダル
    var overlay = $("#overlay"); // オーバーレイ
    var playerContainer = modal.find(".el_movieplayer"); // プレイヤーを入れる場所

    var navBtnOpen = '#nav-btn-open';
    var navBtnClose = '#nav-btn-close';
    var modalBtnClose = '#modal-btn-close';
    var navMenu = '#js_headerMenu'; // メニュー

    // 動画ボタンがクリックされた時
    $(".js_movie_btn").click(function () {
        var videoId = $(this).data("video-id");
        if (!videoId) return false;

        // モーダルとオーバーレイを開く
        modal.fadeIn();
        winScrollTop = $(window).scrollTop();
        $('body').addClass('fixed').css({ 'top': -winScrollTop });

        // 動画再生処理を関数として切り出す
        function playVideo() {
            playerContainer.empty();

            var iframe = document.createElement("iframe");
            iframe.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&showinfo=0&modestbranding=1&autohide=1&fs=0&iv_load_policy=3&autoplay=1`;
            iframe.frameBorder = "0";
            iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
            iframe.allowFullscreen = true;
            iframe.style.width = "100%";
            iframe.style.height = "auto";
            iframe.style.display = "block";

            playerContainer.append(iframe);

            var player = new YT.Player(iframe, {
                events: {
                    "onStateChange": function (event) {
                        if (event.data === YT.PlayerState.ENDED) {
                            showThumbnail(); // 終わったらサムネに戻す
                        }
                    },
                },
            });
        }

        function showThumbnail() {
            playerContainer.empty();

            var thumbnailImg = document.createElement("img");
            thumbnailImg.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
            thumbnailImg.style.width = "100%";
            thumbnailImg.style.height = "auto";
            thumbnailImg.style.objectFit = "cover";
            thumbnailImg.style.cursor = "pointer";

            // クリックで動画再生を再開
            thumbnailImg.addEventListener("click", function () {
                playVideo();
            });

            playerContainer.append(thumbnailImg);
        }

        // 初回クリック時は動画再生からスタート
        playVideo();

        return false;
    });

    $(navBtnOpen).click(function () {
        if ($(navMenu).css('display') === 'none') {
            $(navMenu).fadeIn();
        } else {
            $(navMenu).fadeOut();
        }
        winScrollTop = $(window).scrollTop();
        $('body').addClass('fixed').css({ 'top': -winScrollTop });

        window.isMenuOpen = true;
        if (typeof ScrollTrigger !== "undefined") {
            ScrollTrigger.normalizeScroll(false);
            console.log("メニューOPEN → normalizeScroll 強制OFF");
        }
        return false;
    });

    $(navBtnClose).on('click', function () {
        if ($('body').hasClass('fixed')) {
            $(navMenu).fadeOut();
        }
        $('body').removeClass('fixed').css({ 'top': 0 });
        setTimeout(() => {
            $('body,html').scrollTop(winScrollTop);
        }, 10);

        window.isMenuOpen = false;
        updateNormalizeScrollBySection();
        return false;
    });

    $(overlay).on('click', function () {
        if ($('body').hasClass('fixed')) {
            $(navMenu).fadeOut();
        }
        $('body').removeClass('fixed').css({ 'top': 0 });
        setTimeout(() => {
            $('body,html').scrollTop(winScrollTop);
        }, 10);
        $('.ly_3dsound_popup').fadeOut(400);
        setCookie(modalKey, now, hideDuration);

        window.isMenuOpen = false;
        updateNormalizeScrollBySection();
        return false;
    });

    $(".js_movie_closebtn, #overlay").on("click", function () {
        modal.fadeOut();
        $("body").removeClass("fixed").css({ top: 0 });
        setTimeout(() => {
            $('body,html').scrollTop(winScrollTop);
        }, 10);
        playerContainer.empty();

        window.isMenuOpen = false;
        updateNormalizeScrollBySection();
        return false;
    });

    function updateNormalizeScrollBySection() {
        if (window.isMenuOpen) {
            return;
        }
        if (typeof ScrollTrigger === "undefined") {
            return;
        }

        const scrollY = window.scrollY;
        const winH = window.innerHeight;

        const sections = [
            document.querySelector("#mainVisual"),
            document.querySelector("#speakerArchitecture"),
        ].filter(Boolean);

        if (sections.length === 0) {
            ScrollTrigger.normalizeScroll(false);
            return;
        }

        const isInTarget = sections.some(section => {
            const rect = section.getBoundingClientRect();
            const top = rect.top + scrollY;
            const bottom = rect.bottom + scrollY;
            return scrollY + winH > top && scrollY < bottom;
        });

        ScrollTrigger.normalizeScroll(isInTarget);
        console.log(`normalizeScroll: ${isInTarget ? "ON（対象セクション内）" : "OFF（対象外）"}`);
    }


    //demo page
    const modalKey = 'seen_3dsound_modal';
    const hideDuration = 3 * 24 * 60 * 60 * 1000; // 3日間
    const lastSeen = getCookie(modalKey);
    const now = Date.now();

    function showModal() {
        if ($('.js_3dsound_modal').length) {
            $('.js_fade_in').removeClass('js_fade_in');
            $('.ly_3dsound_popup').fadeIn(400);
            winScrollTop = $(window).scrollTop();
            $('body').addClass('fixed').css({ 'top': -winScrollTop });
        }
    }
    function closeModal() {
        if ($('body').hasClass('fixed')) {
            $(navMenu).fadeOut();
        }
        $('body').removeClass('fixed').css({ 'top': 0 });
        $('body,html').scrollTop(winScrollTop);
        $('.ly_3dsound_popup').fadeOut(400);
        if ($('#js_demo_check').is(':checked')) {
            setCookie(modalKey, now, hideDuration);
        }
    }

    if (!lastSeen || now - lastSeen > hideDuration) {
        showModal();
    }
    $('#js_btn_modal').on('click', function () {
        $('.ly_demomodal_check, .ly_modal_closeArea').hide();
        showModal();
    });
    $('#js_modal_txtclose, #modal-btn-close').on('click', function () {
        closeModal();
        return false;
    });

    // Cookie設定
    function setCookie(name, value, durationMs) {
        const expires = new Date();
        expires.setTime(expires.getTime() + durationMs);
        document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
    }
    // Cookie取得
    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }
    // contact
	const $mail = $(".mail_contact");
	if ($mail.length > 0) {
		initMail($mail);
	}
    function initMail($obj) {
        $obj.each(function(){
            var initTxt = $(this).find("a").attr("data-to");
            var initTxtSub = $(this).find("a").attr("data-subj");
            var escStr = "@";
            var dom = "kjm-ops-support.jp";

            var newTxt = initTxt + escStr + dom;

            $(this).find("a").on("click", function(){
                location.href = "mailto:" + newTxt + "?subject=" + encodeURIComponent(initTxtSub);
                return false;
            });
        });
    }

    // smooth scroll
	$('a:not(.nosmooth)[href*="#"]').click(function() {
		var headHeight = $("header").outerHeight();
		const speed = 400;
		const target = $(this.hash === '#' || '' ? 'html' : this.hash)
		if (!target.length) return;
		const position = target.offset().top - headHeight;
        console.log(position);
		$('body,html').animate({
			scrollTop: position
		}, speed, 'swing');
		return false;
	});

	// to top btn
	$(".el_btn_pageTop").hide();
	$(window).on("scroll", function() {
		if ($(this).scrollTop() > 100) {
			$(".el_btn_pageTop").fadeIn("fast");
		} else {
			$(".el_btn_pageTop").fadeOut("fast");
		}
		var scrollHeight = $(document).height();
		var scrollPosition = $(window).height() + $(window).scrollTop();
		var topBtnHeight = $('.el_btn_pageTop').height() / 2;
		var footHeight = $("footer").innerHeight();
		if (scrollHeight - scrollPosition <= footHeight) {
			$(".el_btn_pageTop").css({
				"position": "absolute",
				"bottom": footHeight - topBtnHeight
			});
		} else {
			$(".el_btn_pageTop").css({
				"position": "fixed",
				"bottom": "4rem"
			});
		}
	});
	$('.el_btn_pageTop').on('click', function() {
		$('body,html').animate({
			scrollTop: 0
		}, 400);
	});
    // qa toggle
    if ($(".js_qa_toggle").length) {
        $(".js_qa_toggle .bl_qa_a").hide();
        $(".js_qa_toggle .bl_qa_q").on("click", function() {
            $(this).next(".bl_qa_a").slideToggle();
            $(this).toggleClass('is_open');
        });
    }        

    //  top page ------------------------------------------------------
    if ($("body").attr("id") !== "top") {
        var headerHeight = $(".ly_global_menu").outerHeight();
        $("main").css("padding-top", headerHeight);
    }
});
